export const FETCH_CALENDAR_API_DATA = "FETCH_CALENDAR_API_DATA";
export const FETCH_APPOINTMENT_DATA = "FETCH_APPOINTMENT_DATA";
